"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleModelListForYear_Make = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const VehicleModel_1 = require("../models/VehicleModel");
const PATH = 'vehicle-models';
async function vehicleModelListForYear_Make(year, make, firestore) {
    const results = await firestore.list(PATH, {
        where: [
            ['year', '==', year],
            ['make', '==', make],
        ],
    });
    const models = results.map(result => (0, VehicleModel_1.vehicleModelDeserialize)(result.value, result.id));
    return (0, sortBy_1.default)(models, vehicle => vehicle.name);
}
exports.vehicleModelListForYear_Make = vehicleModelListForYear_Make;
